import { useTranslate } from "ra-core";
import { Card } from "@/components/ui/card";

import { AddTask } from "./AddTask";
import { TasksListByDueDate } from "./TasksListByDueDate";

/**
 * «Задачи»: my tasks, overdue first, then today, tomorrow, this week and
 * later. A click on the checkbox marks a task done.
 */
export const TasksPage = () => {
  const translate = useTranslate();
  return (
    <div className="max-w-3xl mx-auto mt-2 flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold tracking-tight">
          {translate("resources.tasks.name", { smart_count: 2 })}
        </h1>
        <AddTask display="button" selectContact />
      </div>
      <Card className="p-4">
        <TasksListByDueDate
          emptyPlaceholder={
            <p className="text-sm text-muted-foreground">
              {translate("resources.tasks.empty_list_hint")}
            </p>
          }
        />
      </Card>
    </div>
  );
};
